import React, { useEffect, useRef, useState } from "react";
import { Grid } from "antd";
import {
  ArrowLeftOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { findScrollParent } from "../../utils/scroll";
import { HEADER_TOP } from "./rentDetailStyle";

// 是否已离开顶部（用于切换 嵌入态 / 磨砂+阴影）
function useScrolled(ref) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const target = findScrollParent(ref.current);
    const read = () =>
      target === window ? window.scrollY : target.scrollTop;
    const on = () => setScrolled(read() > 2);
    on();
    target.addEventListener("scroll", on, { passive: true });
    return () => target.removeEventListener("scroll", on);
  }, [ref]);
  return scrolled;
}

/**
 * 顶栏（常驻吸顶）：返回列表 | 上一条 index/total 下一条
 * index: 当前在待处理列表中的位置(0 起)，找不到为 -1；total<=1 或 index<0 时不显示翻页
 * 两端的上一条/下一条用 visibility 隐藏而不是移除，保证按钮位置固定，连点不会点错
 */
export default function DetailTopBar({ onBack, index, total, onPrev, onNext }) {
  const ref = useRef(null);
  const scrolled = useScrolled(ref);
  const wide = Grid.useBreakpoint().sm; // 窄屏只显示图标
  const showNav = total > 1 && index >= 0;
  const hasPrev = index > 0;
  const hasNext = index < total - 1;

  return (
    <div
      ref={ref}
      className={`rcd-bar${scrolled ? " scrolled" : ""}`}
      style={{ top: HEADER_TOP }}
    >
      <div className="rcd-bar-inner">
        <button type="button" className="rcd-btn" onClick={onBack}>
          <ArrowLeftOutlined />
          返回列表
        </button>
        <span className="rcd-spacer" />
        {showNav && (
          <>
            <button
              type="button"
              className={`rcd-btn${wide ? "" : " icon"}${hasPrev ? "" : " is-hidden"}`}
              onClick={onPrev}
              aria-label="上一条"
              aria-hidden={!hasPrev}
              tabIndex={hasPrev ? 0 : -1}
            >
              <LeftOutlined />
              {wide && "上一条"}
            </button>
            <span className="rcd-counter" aria-live="polite">
              {index + 1} / {total}
            </span>
            <button
              type="button"
              className={`rcd-btn${wide ? "" : " icon"}${hasNext ? "" : " is-hidden"}`}
              onClick={onNext}
              aria-label="下一条"
              aria-hidden={!hasNext}
              tabIndex={hasNext ? 0 : -1}
            >
              {wide && "下一条"}
              <RightOutlined />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
